import { render, staticRenderFns } from "./Efforts.vue?vue&type=template&id=6c0f47a5&scoped=true"
import script from "./Efforts.vue?vue&type=script&lang=js"
export * from "./Efforts.vue?vue&type=script&lang=js"
import style0 from "./Efforts.vue?vue&type=style&index=0&id=6c0f47a5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0f47a5",
  null
  
)

export default component.exports